export default __webpack_public_path__ + "static/media/icon-info.6395f2ff.svg";